module.exports = __webpack_public_path__ + "img/android-logo.f7b88b86.svg";